module.exports = "/_next/static/images/bd9ec9e6126f86a72acca0f9f5113b96-stapler@mobile480.jpg.webp";